class UrlParams {
  constructor () {
    this.getParamsFromUrl()
  }

  getParamsFromUrl () {
    const url = window.location.toString()
    const splitUrl = url.split('?')
    if (splitUrl.length > 1) {
      const baseUrl = splitUrl[0]
      const queryString = splitUrl[1]
      const queries = queryString.split('&')
      this.analyzeParams(queries, baseUrl)
    }
  }

  analyzeParams (queries, baseUrl) {
    queries.forEach(function (query) {
      if (query === 'login_web=true') {
        history.replaceState(null, '', baseUrl)
        Shopify.analytics.publish('customer_login_success', {
          method: 'email'
        })
      } else if (query === 'register_web=true') {
        history.replaceState(null, '', baseUrl)
        Shopify.analytics.publish('customer_register_success', {
          method: 'email'
        })
      }
    })
  }
}

new UrlParams()
